import {
  BaseLayout,
  GetInitialPropsWithPrevious,
  NextI18nService,
} from '@scorenco/next';
import { GetServerSideProps, GetStaticProps } from 'next';

import { buildGetLayout } from './buildGetLayout';

type ScreenLayoutOptions = {
  i18n?: Parameters<typeof NextI18nService.getInitalPropsFn>['0'];
};

export const ScreenLayout = {
  ...BaseLayout,
  buildGetInitialProps: (
    options?: ScreenLayoutOptions,
    list?: GetInitialPropsWithPrevious[]
  ) =>
    BaseLayout.buildGetInitialProps([
      NextI18nService.getInitalPropsFn(options?.i18n),
      ...(list || []),
    ]),
  buildGetServerSideProps: (
    options?: ScreenLayoutOptions,
    list?: GetServerSideProps[]
  ) =>
    BaseLayout.buildGetServerSideProps([
      NextI18nService.getServerSidePropsFn(options?.i18n),
      ...(list || []),
    ]),
  buildGetStaticProps: (
    options?: ScreenLayoutOptions,
    list?: GetStaticProps[]
  ) =>
    BaseLayout.buildGetStaticProps([
      NextI18nService.getStaticPropsFn(options?.i18n),
      ...(list || []),
    ]),
  buildGetLayout,
};
